import { Directive, HostListener, Input } from '@angular/core';
import { ToastService } from 'src/app/utils/services/toast.service';

@Directive({
  selector: '[clipboard]'
})
export class ClipboardDirective {

  @Input() clipboard?: string;

  constructor(private toast: ToastService) { }

  @HostListener('click', ['$event'])
  copyMessage(event: Event) {

    const text = this.clipboard ?? (event.target as HTMLElement).innerText;
    if (!text) return;
    const temp = document.createElement('textarea');
    temp.value = text.replace(/<[^>]+>/g, ''); // Quita HTML si lo hay
    document.body.appendChild(temp);
    temp.select();
    document.execCommand('copy');
    document.body.removeChild(temp);
    this.toast.success('Mensaje copiado al portapapeles',1);
  }

}